
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","viewBox":"0 0 34 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"33","height":"33","rx":"2.5","fill":"#fff","stroke":"#E6E6E6"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.088 23.222a3.3 3.3 0 01-3.298-3.301 3.3 3.3 0 013.299-3.302 3.3 3.3 0 013.298 3.302 3.3 3.3 0 01-3.299 3.301zm-.02-8.367A5.07 5.07 0 009 19.927 5.07 5.07 0 0014.069 25a5.07 5.07 0 005.068-5.073 5.07 5.07 0 00-5.069-5.072z","fill":"#D30D48"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.202 20.816a5.01 5.01 0 01-5.008-5.012 5.01 5.01 0 015.008-5.013 5.01 5.01 0 015.008 5.013 5.01 5.01 0 01-5.008 5.012zM18.215 9a6.787 6.787 0 00-6.784 6.79c0 3.75 3.037 6.79 6.784 6.79A6.787 6.787 0 0025 15.79C25 12.04 21.962 9 18.215 9z","fill":"#2AAACD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.278 16.72a3.3 3.3 0 014.009 4.013 5.038 5.038 0 001.785.008 5.07 5.07 0 00-5.8-5.824 5.039 5.039 0 00.006 1.803z","fill":"#F9BA30"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.242 20.816l-.04.001a5.01 5.01 0 01-5.008-5.013h-.001v-.04a.882.882 0 10-1.762 0v.026c0 3.75 3.037 6.79 6.784 6.79h.027a.882.882 0 000-1.764z","fill":"#55548F"}})])
          )
        }
      }
    